<script>
  import { AppStore } from '../stores/AppStore'
  export let podcastID;

  $: selected = $AppStore.state.activePodcastID === podcastID

</script>

<style>

  .cards {
    max-height: 300px;
  }

</style>

<div
  class="cards w-full h-12 sm:h-auto rounded-lg bg-gray-300 flex flex-col overflow-hidden group select-none relative box-border border-gray-300 border-0 sm:border-4 justify-center"
  class:hover:bg-gray-200={!selected}
  class:hover:border-gray-200={!selected}
  class:bg-blue-500={selected}
  class:cursor-pointer={!selected}
  class:bg-blue-300={selected}
  class:pointer-events-none={selected}
  class:border-blue-500={selected}
  on:click={() => AppStore.selectPodcastWithID(podcastID)}
>
  <img 
    src="./thumbs/{$AppStore.podcasts[podcastID].thumb}" 
    alt={$AppStore.podcasts[podcastID].name} 
    class="hidden sm:flex w-full object-cover group-hover:opacity-75 rounded-md overflow-hidden"
  >
  <div
    class="w-full flex-shrink-0 h-10 px-2 flex items-center"
    class:text-gray-100={selected}
  >
    <span class="">{$AppStore.podcasts[podcastID].name}</span>
  </div>
</div>